import { render, staticRenderFns } from "./network-error.vue?vue&type=template&id=18c1e0fe"
import script from "./network-error.vue?vue&type=script&lang=js"
export * from "./network-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports